import { CommonModule } from '@angular/common'
import { Component, OnInit } from '@angular/core'
import { Router, RouterModule } from '@angular/router'
import { AuthService } from '../../../auth/services/auth.service'
import { ActionEditorComponent } from './components/action-editor/action-editor.component'
import { ActionsManagerComponent } from './components/actions-manager/actions-manager.component'
import { ComponentEditorComponent } from './components/component-editor/component-editor.component'
import { ComponentManagerComponent } from './components/component-manager/component-manager.component'
import { ComposerHeaderComponent } from './components/composer-header/composer-header.component'
import { TemplateEditorComponent } from './components/template-editor/template-editor.component'
import { TemplateListComponent } from './components/template-list/template-list.component'
import { ThemeEditorComponent } from './components/theme-editor/theme-editor.component'
import { ThemeManagerComponent } from './components/theme-manager/theme-manager.component'
import { EmailComposerView } from './services/email-composer-state.service'

@Component({
  selector: 'ngx-email-composer',
  templateUrl: './email-composer.component.html',
  styleUrls: ['./email-composer.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    TemplateListComponent,
    TemplateEditorComponent,
    ComponentManagerComponent,
    ComponentEditorComponent,
    ThemeManagerComponent,
    ThemeEditorComponent,
    ActionsManagerComponent,
    ActionEditorComponent,
    ComposerHeaderComponent
  ]
})
export class EmailComposerComponent implements OnInit {
  activeView: EmailComposerView = 'templates'
  editingTemplateId: number | null = null
  editingComponentId: number | null = null
  editingThemeId: number | null = null
  editingActionId: number | null = null

  constructor(
    private router: Router,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    // Check admin access
    if (!this.authService.isAdmin) {
      this.router.navigate(['/'])
      return
    }

    // Check workspace selection
    if (!this.authService.currentWorkspace) {
      this.router.navigate(['/workspaces'])
      return
    }
  }

  setActiveView(view: EmailComposerView): void {
    this.activeView = view
  }

  // Template Navigation
  onTemplateEdit(templateId: number): void {
    this.editingTemplateId = templateId
    this.setActiveView('template-editor')
  }

  onTemplateCreate(): void {
    this.editingTemplateId = null
    this.setActiveView('template-editor')
  }

  onBackToTemplates(): void {
    this.editingTemplateId = null
    this.setActiveView('templates')
  }

  // Component Navigation
  onComponentEdit(componentId: number): void {
    this.editingComponentId = componentId
    this.setActiveView('component-editor')
  }

  onComponentCreate(): void {
    this.editingComponentId = null
    this.setActiveView('component-editor')
  }

  onBackToComponents(): void {
    this.editingComponentId = null
    this.setActiveView('components')
  }

  onComponentSaved(component: any): void {
    this.onBackToComponents()
  }

  // Theme Navigation
  onThemeEdit(themeId: number): void {
    this.editingThemeId = themeId
    this.setActiveView('theme-editor')
  }

  onThemeCreate(): void {
    this.editingThemeId = null
    this.setActiveView('theme-editor')
  }

  onBackToThemes(): void {
    this.editingThemeId = null
    this.setActiveView('themes')
  }

  onThemeSaved(theme: any): void {
    this.onBackToThemes()
  }

  // Actions Navigation
  onActionEdit(actionId: number): void {
    this.editingActionId = actionId || null
    this.setActiveView('action-editor')
  }

  onBackToActions(): void {
    this.editingActionId = null
    this.setActiveView('actions')
  }

  onActionSaved(_: any): void {
    this.onBackToActions()
  }
}
